import { cn } from '@prenuvo/halo';

export interface SkeletonProps {
  'aria-label'?: string;
  className?: string;
  /**
   * Number of skeleton items to render
   * @default 1
   */
  count?: number;
  testId?: string;
}

export function Skeleton({ 'aria-label': ariaLabel, className, count = 1, testId }: SkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={`skeleton-${index}`}
          aria-label={ariaLabel}
          className={cn('animate-pulse rounded-md bg-neutral-700/30', className)}
          data-testid={testId}
          role="status"
        />
      ))}
    </>
  );
}
